//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';


//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_DATA_INTEGRANTES = "GET_DATA_INTEGRANTES";
export const ABRIR_POPUP = "ABRIR_POPUP";
export const TIENE_HISTORIAL_TARJETAS = "TIENE_HISTORIAL_TARJETAS";
export const GET_HISTORIAL_TARJETAS = "GET_HISTORIAL_TARJETAS";
export const RESULTADO_ACCION_TARJETA = "RESULTADO_ACCION_TARJETA";
export const ERROR_VALIDACION_INTEGRANTES = "ERROR_VALIDACION_INTEGRANTES";
export const ACTUALIZAR_INTEGRANTES = "ACTUALIZAR_INTEGRANTES";
export const CHECK_REIMPRESION_TARJETA = "CHECK_REIMPRESION_TARJETA";

let _dispatch;
let _tarjetas;
let ctaTarjetaId;

export function getScreenDataIntegrantes(cuentaTarjetaId) {
    LogHelper.In(getScreenDataIntegrantes.name, cuentaTarjetaId);

    ctaTarjetaId = cuentaTarjetaId;

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let state = getState();
        let clienteId = state.tarjetas.Cliente.Id;

        let paramIntegrantes = {
            'CUENTA_TARJETA_ID': cuentaTarjetaId
        };

        let paramNovedades = {
            'CLIENTE_ID': parseInt(clienteId)
        };
        
        Engine1Proxy.AddDataSourcesRequests(paramIntegrantes, 'UP_GET_INTEGRANTES_CUENTA_BY_CUENTATARJETAID_Grilla', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'integrantesCuenta');
        Engine1Proxy.AddDataSourcesRequests(paramNovedades, 'UP_GET_INTEGRANTES_BY_CLIENTEID_ModificacionDatos', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'novedades');

        Engine1Proxy.Execute((data) => _callbackgetScreenDataIntegrantes(data), null, null, "CONSULTASOCIOS");

    }
}

export function checkReimpresion(){
    return (dispatch, getState) => {
        dispatch({type:CHECK_REIMPRESION_TARJETA})
    }
}

export function obtenerHisotrialTarjetas(modalId, abrirCerrar) {
    return (dispatch, getState) => {
        _dispatch = dispatch;
        let state = getState();

        let paramIntegrantes = {
            'CUENTA_TARJETA_ID': ctaTarjetaId
        };

        Engine1Proxy.AddDataSourcesRequests(paramIntegrantes, 'SP_GET_HISTORIAL_TARJETAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'HistorialTarjetas');
        Engine1Proxy.Execute((data) => _callbackgetHistorialTarjetas(data, modalId, abrirCerrar,dispatch), null, null, "CONSULTASOCIOS");
    }
}

function _callbackgetHistorialTarjetas(data, modalId, abrirCerrar,dispatch) {
    
    var historialTarjetasCount = JSON.parse(data.HistorialTarjetas).Recordset0.Rows.length;
    var tieneHistorialTarjeta, HistorialTarjetas;
     
    if (historialTarjetasCount > 0){
        tieneHistorialTarjeta = true;
        HistorialTarjetas = JSON.parse(data.HistorialTarjetas).Recordset0.Rows;

        dispatch({ type: TIENE_HISTORIAL_TARJETAS, tieneHistorialTarjeta });
        dispatch({ type: GET_HISTORIAL_TARJETAS, HistorialTarjetas });
        dispatch({ type: ABRIR_POPUP, modalId, abrirCerrar });
    }
    else{
        tieneHistorialTarjeta = false;
        dispatch({ type: TIENE_HISTORIAL_TARJETAS, tieneHistorialTarjeta });
    }
}

//Abre el historial de tarjetas
export function abrirPopUp(modalId, abrirCerrar) { 
    LogHelper.In(modalId.name, modalId, abrirCerrar);
    return (dispatch, getState) => {
        dispatch({ type: ABRIR_POPUP, modalId, abrirCerrar });
    }
}


export function modificarPinTarjeta(tarjeta){
    return (dispatch,getState)=>{
        _dispatch = dispatch;

        let state = getState();
        let p = state.DatosCuenta.IntegrantesCuenta.nuevoPin; 
        if(p && p.length == 4 && /^[0-9]{0,4}$/.test(p) ){

            let cuentaEntidadNumero = state.tarjetas.cuentaCorriente.CuentaEntidadNumero;
            let producto = state.tarjetas.cuentaCorriente.codigoProducto;
            let body = '{"Pin":"'+ state.DatosCuenta.IntegrantesCuenta.nuevoPin + '"}';
            let ultNumerosTarjeta = tarjeta.NumeroTarjeta;
            ultNumerosTarjeta = ultNumerosTarjeta.split(" ");
            ultNumerosTarjeta = ultNumerosTarjeta[3];
    
            let paramCuentas = {
                'numeroCuenta': cuentaEntidadNumero,
                'idProducto': producto,
                'body': body,
                'tarjeta': ultNumerosTarjeta,
                'Pin': state.DatosCuenta.IntegrantesCuenta.nuevoPin
            }
            
            Engine1Proxy.AddDataSourcesRequests(paramCuentas, 'MODIFICAR_PIN_TARJETA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'modificacionPinTarjeta');
            Engine1Proxy.Execute((data) => _modificarPinTarjetaCallback(data), null, null, "CONSULTASOCIOS");
        }else{
            dispatch({type: ERROR_VALIDACION_INTEGRANTES, campo:"PIN", valida:false})
        }
 
    }
}

function _modificarPinTarjetaCallback(data){
    var GpRespuesta = JSON.parse(data.modificacionPinTarjeta).Recordset0.Rows[0];

    _dispatch({type:RESULTADO_ACCION_TARJETA, tipoAccion: "PIN", resultado: !GpRespuesta.IsError})
    _dispatch({type: ERROR_VALIDACION_INTEGRANTES, campo:"PIN", valida:true})
    
}

export function cambiarEstadoTarjeta(tarjeta,estado){
    LogHelper.In(cambiarEstadoTarjeta.name, tarjeta, estado);
    
    return (dispatch,getState)=>{
        _dispatch = dispatch;
        let state = getState();
        let cuentaTarjetaId = state.tarjetas.cuentaCorriente.Id;
        let cuentaEntidadNumero = state.tarjetas.cuentaCorriente.CuentaEntidadNumero;
        let producto = state.tarjetas.cuentaCorriente.codigoProducto;
        let ultNumerosTarjeta = tarjeta.NumeroTarjeta;
            ultNumerosTarjeta = ultNumerosTarjeta.split(" ");
            ultNumerosTarjeta = ultNumerosTarjeta[3];
        let body = '{"NuevoEstado":"'+ estado + '"}';

        let paramCuentas = {
            'numeroCuenta': cuentaEntidadNumero,
            'idProducto': producto,
            'body': body,
            'tarjeta': ultNumerosTarjeta,
            'Estado':estado
        }
        
        Engine1Proxy.AddDataSourcesRequests(paramCuentas, 'CAMBIAR_ESTADO_TARJETA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'cambiarEstadoTarjeta');
        Engine1Proxy.Execute((data) => _cambiarEstadoTarjetaCallback(data, estado, cuentaTarjetaId,tarjeta.TarjetaCreditoId), null, null, "CONSULTASOCIOS");

    }
}

function _cambiarEstadoTarjetaCallback(data, estado, cuentaTarjetaId,tarjetaId){
    var GpRespuesta = JSON.parse(data.cambiarEstadoTarjeta).Recordset0.Rows[0];
    let strEstado = "ESTADO-TARJETA-"+estado.toUpperCase().replace(" ","-");
    
    if(!GpRespuesta.IsError){
        _dispatch({type:RESULTADO_ACCION_TARJETA, tipoAccion: "ESTADO-TARJETA-"+estado.toUpperCase().replace(" ","-"), resultado: true});
        
        let localValues = {"TARJETA_CREDITO_ESTADO_ID":"", "ESTA_BLOQUEADA":""}
        let isQuery = false;
        let deleteInstance = false;

        switch(estado){
            case "Normal":{
                localValues.TARJETA_CREDITO_ESTADO_ID = 3;
                localValues.ESTA_BLOQUEADA = 0;
                break;
            }
            case "BloqueoTemporal":{
                localValues.TARJETA_CREDITO_ESTADO_ID = 4;
                localValues.ESTA_BLOQUEADA = 1;
                break;
            }
        }
        
        Engine1Proxy.AddEventSourcingDataRequest(localValues, "EVENTSOURCING_TRANSACTION_TARJETA_CREDITO", 'Tarjetas', "ADMINEMPCUETAR", null, isQuery, null, deleteInstance, tarjetaId);
        Engine1Proxy.Execute(()=>_actualizarIntegrantes(cuentaTarjetaId), null, null, "ADMINEMPCUETAR");
    }else{
        _dispatch({type:RESULTADO_ACCION_TARJETA, tipoAccion: strEstado, resultado: false});

    }

}

/**FUNCIONES AUXILIARES */

function _callbackgetScreenDataIntegrantes(data) {
    var integrantesCuenta = JSON.parse(data.integrantesCuenta).Recordset0.Rows;
    var novedades = JSON.parse(data.novedades).Recordset0.Rows;
    integrantesCuenta.map(int=>{
        int.FVencimiento = new Date(int.FechaVencimiento);
        int.FechaVencimiento;
        int.FechaVencimiento = int.FechaVencimiento.split("T")[0];
        int.FechaVencimiento = int.FechaVencimiento.split("-");
        int.FechaVencimiento = int.FechaVencimiento[1] + "/" + int.FechaVencimiento[0].substring(2,4);
        if(int.VinculoTarjeta.includes("Exten")) int.VinculoTarjeta = "Extensión";
    })
    
    _dispatch({ type: GET_DATA_INTEGRANTES, integrantesCuenta, novedades });
}

function _actualizarIntegrantes(cuentaTarjetaId){

    let params = {
        'CUENTA_TARJETA_ID': parseInt(cuentaTarjetaId)
    };
    
    Engine1Proxy.AddDataSourcesRequests(params, 'UP_GET_INTEGRANTES_CUENTA_BY_CUENTATARJETAID_Grilla', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'integrantesCuenta');
    
    Engine1Proxy.Execute((data) => _actualizarIntegrantesCallback(data), null, null, "CONSULTASOCIOS");
}

function _actualizarIntegrantesCallback(data){
    var integrantesCuenta = JSON.parse(data.integrantesCuenta).Recordset0.Rows;
    
    integrantesCuenta.map(int=>{
        int.FechaVencimiento;
        int.FechaVencimiento = int.FechaVencimiento.split("T")[0];
        int.FechaVencimiento = int.FechaVencimiento.split("-");
        int.FechaVencimiento = int.FechaVencimiento[2] + "/" + int.FechaVencimiento[1];
        if(int.VinculoTarjeta.includes("Exten")) int.VinculoTarjeta = "Extensión";
    })

    _dispatch({ type: ACTUALIZAR_INTEGRANTES, integrantesCuenta });
    _dispatch({type:RESULTADO_ACCION_TARJETA, tipoAccion: "ESTADO-TARJETA-NORMAL", resultado: true});
}


"2024-03-10T00:00:00"